import React, { useEffect, useState } from "react";
import CommonDropDown from "../../components/dropdown";
import Input from "../../components/input";
import Datepicker from "react-tailwindcss-datepicker";
import { GET_POLICE_STATION_LIST } from "../../utils/constants";
import { ApiHandle } from "../../utils/ApiHandle";
import { useSelector } from "react-redux";
import { FaDownload } from "react-icons/fa";
import Select from "react-select";
import { CASE_TYPE } from "../../utils/constants";
import { useLocation } from "react-router-dom";

function FilterSection({
  filter,
  setFilter,
  getAllRequest,
  dateRange,
  setDateRange,
  exportReport,
  clearFilter,
  PdfExport,
  pdfHeaderModal,
}) {
  const { rank } = useSelector((state) => state.user?.userData);
  const [caseType, setCaseType] = useState([]);
  const location = useLocation();

  const from_status_option = [
    { id: 4, name: "All", value: "All" },
    { id: 1, name: "PENDING", value: "PENDING" },
    { id: 2, name: "APPROVE", value: "APPROVE" },
    { id: 3, name: "REJECT", value: "REJECT" },
  ];

  const req_to_provider_option = [
    { id: 1, name: "CDR", value: "CDR" },
    { id: 2, name: "IPDR", value: "IPDR" },
    { id: 3, name: "TDR", value: "TDR" },
    { id: 4, name: "CAF", value: "CAF" },
  ];
  const target_type_option = [
    { id: 1, name: "MOBILE_NUMBER", value: "MOBILE_NUMBER" },
    { id: 2, name: "IMEI_NUMBER", value: "IMEI_NUMBER" },
    { id: 3, name: "CELL_ID", value: "CELL_ID" },
    { id: 4, name: "IP_ADDRESS", value: "IP_ADDRESS" },
    { id: 5, name: "ILD", value: "ILD" },
  ];
  const [policeStation, setPoliceStation] = useState([]);
  useEffect(() => {
    getPoliceStaionList();
    getCaseType();
  }, []);
  const getPoliceStaionList = async () => {
    const res = await ApiHandle(`${GET_POLICE_STATION_LIST}`, {}, "get");
    if (res.statusCode === 200) {
      const data = res?.responsePayload || [];
      const arr = data.map((station) => ({
        ...station,
        value: station.id,
        label: station.name, // Assuming 'name' is the label for the dropdown options
      }));
      setPoliceStation(arr);
    } else {
      console.error("Failed to fetch police stations:", res.error); // Handle error cases if necessary
    }

    return;
  };

  const handleValueChange = (newValue) => {
    setDateRange(newValue);
  };

  const isDateSelected = !!(dateRange?.startDate && dateRange?.endDate);
  const autoApprovedOptions = [
    { id: true, name: "Yes" },
    { id: false, name: "No" },
    { id: "", name: "All" },
  ];

  const [selectedOptions, setSelectedOptions] = useState([]);

  const handleSelectChange = (selected) => {
    setSelectedOptions(selected);

    let selectedPoliceStation = "";
    selected.map((e) => {
      selectedPoliceStation = e.name + "," + selectedPoliceStation;
    });
    setFilter({ ...filter, police_station: selectedPoliceStation });

    // setFilter()
  };
  const getCaseType = async () => {
    try {
      const res = await ApiHandle(`${CASE_TYPE}`, "", "get");
      if (res?.statusCode === 200) {
        let data = res?.responsePayload?.map((val) => ({
          id: val.id,
          value: val.name,
          name: val.name,
        }));
        setCaseType(data);
      }
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <div className="inner-div-filter">
      <div className=" flex-flex-row w-[100%]">
        <div className="flex flex-col w-[100%] justify-between p-2 items-center gap-4">
          {/* <div>
        <CommonDropDown
          name={"req_to_provider"}
          options={req_to_provider_option}
          onChange={(e) => {
            setFilter({ ...filter, [e.target.name]: e.target.value });
          }}
          label="Request to provider"
        />
      </div> */}
          <div className="w-full flex justify-between gap-4">
            {["/unverified-form", "/rejected-form"].includes(
              location.pathname
            ) ? (
              ""
            ) : (
              <div className="w-full">
                <label htmlFor=""> Form Status</label>
                <CommonDropDown
                  name={"form_status"}
                  options={from_status_option}
                  onChange={(e) => {
                    setFilter({
                      ...filter,
                      [e.target.name]: e.target.value,
                    });
                  }}
                  label={""}
                  placeholder="All"
                  hidden={true}
                  value={filter["form_status"]}
                />
              </div>
            )}
            {/* //////////////////// */}
            <div className="w-full">
              <label htmlFor=""> Select Date</label>
              <div className="date-filter text-black-900 border border-gray-300 rounded-lg bg-blue-100 focus:ring-blue-500 focus:border-blue-500">
                <Datepicker
                  primaryColor={"teal"}
                  value={dateRange}
                  onChange={handleValueChange}
                  showShortcuts={true}
                  maxDate={new Date()}
                  classNames="border border-solid"
                />
              </div>
            </div>
          </div>

          <div className="w-full flex justify-between gap-4">
            <div className="w-full">
              <label htmlFor=""> FIR NO.</label>
              <Input
                name="case_ref"
                onChange={(e) => {
                  setFilter({ ...filter, [e.target.name]: e.target.value });
                }}
                label=""
                placeholder="Enter FIR no."
                value={filter.case_ref}
              />
            </div>
            {/* <div className="w-full">
              <label htmlFor=""> Case Type</label>

              <Input
                name="case_type"
                onChange={(e) => {
                  setFilter({...filter, [e.target.name]: e.target.value});
                }}
                label=""
              />
            </div> */}
            <div className="w-full ">
              <label className="font ">Crime Head:</label>

              <CommonDropDown
                name="case_type"
                options={caseType}
                value={filter["case_type"]}
                onChange={(e) => {
                  setFilter({ ...filter, [e.target.name]: e.target.value });
                }}
                label=""
                placeholder="All"
                // isDisabled={!isEditable && requestData}
              />

              {/* <CommonDropDown
                  name={"form_status"}
                  options={from_status_option}
                  onChange={(e) => {
                    setFilter({
                      ...filter,
                      [e.target.name]:
                        e.target.value == "All" ? "" : e.target.value,
                    });
                  }}
                  label={""}
                  value={filter["form_status"]}
                /> */}
            </div>
          </div>

          <div className="flex justify-between w-full gap-4">
            <div className="w-full">
              {["DCP"].includes(rank) ? (
                <>
                  <label htmlFor=""> Auto Approved</label>
                  <CommonDropDown
                    name={"auto_approved"}
                    options={autoApprovedOptions}
                    checkId={true}
                    onChange={(e) => {
                      setFilter({ ...filter, [e.target.name]: e.target.value });
                    }}
                    label=""
                    placeholder="All"
                    hidden={true}
                    value={filter.auto_approved}
                  />
                </>
              ) : (
                ""
              )}
            </div>
            {/* <div className="flex w-[100%] justify-between "> */}
            {/* <div className="w-full">
              {["DCP"].includes(rank) && (
                <CommonDropDown
                  name={"police_station"}
                  options={policeStation}
                  checkId={true}
                  onChange={(e) => {
                    setFilter({ ...filter, [e.target.name]: e.target.value });
                  }}
                  label="Police Station"
                />
              )}
            </div> */}
            <div className="w-full">
              {["DCP"].includes(rank) && (
                // <CommonDropDown
                //   name={"police_station"}
                //   options={policeStation}
                //   checkId={true}
                //   onChange={(e) => {
                //     setFilter({ ...filter, [e.target.name]: e.target.value });
                //   }}
                //   label="Police Station"
                // />
                <>
                  <label htmlFor=""> Police Station</label>

                  <Select
                    options={policeStation}
                    isMulti
                    onChange={handleSelectChange}
                    value={selectedOptions}
                    label={selectedOptions}
                    className="bg-blue-300"
                  />
                </>
              )}
            </div>
            {/* </div> */}
          </div>
          <div className="flex w-full justify-between gap-4  items-center">
            <div className="w-full">
              <label htmlFor="target_type"> Search Type</label>
              <CommonDropDown
                id="target_type"
                name={"target_type"}
                options={target_type_option}
                onChange={(e) => {
                  setFilter({ ...filter, [e.target.name]: e.target.value });
                }}
                label=""
                placeholder="All"
                value={filter["target_type"]}
              />
            </div>

            <div className="w-full  ">
              {filter["target_type"] !== "" && (
                <>
                  <label htmlFor=""> Select Target Type Value</label>
                  <Input
                    type="text"
                    placeholder="Enter value"
                    value={filter["target_type_value"]}
                    required={true}
                    name="target_type_value"
                    onChange={(e) =>
                      setFilter({ ...filter, [e.target.name]: e.target.value })
                    }
                    className="w-[100%]"
                  />
                </>
              )}
            </div>
          </div>

          <div className="flex w-[100%] justify-between items-start mt-2">
            <div className="flex gap-3 mt-6">
              <button
                onClick={getAllRequest}
                style={{
                  width: "100px",
                  border: "2px solid green",
                  borderRadius: "20px",
                  height: "40px",
                }}
              >
                <b>Search</b>
              </button>

              <button
                onClick={clearFilter}
                type="button"
                style={{
                  width: "100px",
                  border: "2px solid green",
                  borderRadius: "20px",
                  height: "40px",
                }}
              >
                <b>Clear Filter</b>
              </button>
            </div>

            {["DCP"].includes(rank) && (
              <div className="flex flex-col items-end">
                <span className="text-sm font-medium mb-1">Download Data</span>
                <div className="flex gap-2">
                  {[
                    { label: "Excel", onClick: exportReport },
                    { label: "PDF", onClick: pdfHeaderModal },
                  ].map((btn) => (
                    <button
                      key={btn.label}
                      type="button"
                      onClick={btn.onClick}
                      disabled={!isDateSelected}
                      title={
                        isDateSelected
                          ? `Download ${btn.label}`
                          : "Select a date range to download"
                      }
                      className={`flex items-center gap-2 px-3 h-10 rounded-full border-2 font-bold ${
                        isDateSelected
                          ? "border-green-700 text-black"
                          : "border-gray-300 text-gray-400 cursor-not-allowed"
                      }`}
                    >
                      <FaDownload size={14} />
                      {btn.label}
                    </button>
                  ))}
                </div>
                {!isDateSelected && (
                  <span className="text-xs text-gray-500 mt-1">
                    Select a date range to download
                  </span>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default FilterSection;
